/* ===========================================================================
 * 08 Left - Frame Upsell  (Selly replacement)
 * ---------------------------------------------------------------------------
 * When a PAPER print is added to cart, pops a modal offering the matching-size
 * frame (Black / White / Natural Wood, with photos) at full price, one click
 * to add. Pure theme JS - reads Shopify's own product data, no backend.
 *
 * Skips: metal prints, sizes with no matching frame (e.g. 4x6), the frames
 * product itself, and prints whose matching frame is already in the cart.
 *
 * Load once globally (e.g. a Custom Liquid block in the theme footer):
 *   <script src="{{ 'frame-upsell.js' | asset_url }}" defer></script>
 *
 * Pure ASCII on purpose (special chars via HTML entities / \u) so a paste into
 * Shopify can never corrupt it.
 * ======================================================================== */
(function () {
  "use strict";
  if (window.__frameUpsellLoaded) return;
  window.__frameUpsellLoaded = true;

  var VERSION = "2026-07-29.2";
  console.log("%c[08L frame-upsell] " + VERSION, "color:#0a0a0a;background:#f9cb0c;padding:2px 6px;border-radius:3px;font-weight:700");

  var FRAMES_HANDLE = "frames";
  var INK = "#0a0a0a", YELLOW = "#f9cb0c", RED = "#c42126";
  var FONT = '"proxima-nova","Proxima Nova",-apple-system,BlinkMacSystemFont,"Helvetica Neue",Helvetica,Arial,sans-serif';

  var state = { suppress: false, open: false, frameMap: null, cssDone: false };

  // ---- helpers -----------------------------------------------------------
  function money(cents) {
    var s = (cents / 100).toFixed(2);
    return "$" + s.replace(/\.00$/, "");
  }
  // Orientation-agnostic: "30 x 20" and "20 x 30" are the same size (a 30x20
  // blend fits a 20x30 frame), so we sort the two dimensions before comparing.
  function normSize(s) {
    s = (s || "").toLowerCase().replace(/\s+/g, "").replace(/[\u00d7x]/g, "x");
    var m = s.match(/^(\d+)x(\d+)$/);
    if (m) { var a = +m[1], b = +m[2]; return Math.min(a, b) + "x" + Math.max(a, b); }
    return s;
  }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  // ---- frames product -> { size: [ {color, variantId, price, image} ] } --
  function loadFrames() {
    if (state.frameMap) return Promise.resolve(state.frameMap);
    var mock = window.__FRAME_UPSELL_FRAMES__;
    var p = mock ? Promise.resolve(mock) : fetch("/products/" + FRAMES_HANDLE + ".js").then(function (r) { return r.json(); });
    return p.then(function (data) {
      var map = {};
      (data.variants || []).forEach(function (v) {
        var opts = v.options || [];
        var size = (opts[0] || "").trim(), color = (opts[1] || "").trim();
        if (!size || !v.available) return;
        (map[size] = map[size] || []).push({
          color: color, variantId: v.id, price: v.price,
          image: (v.featured_image && v.featured_image.src) || (data.images && data.images[0]) || ""
        });
      });
      state.frameMap = map;
      return map;
    });
  }

  // ---- read size + material from an added line item ----------------------
  function itemSpecs(item) {
    var size = "", material = "", allVals = "";
    var owv = item.options_with_values;
    if (Array.isArray(owv)) {
      owv.forEach(function (o) {
        var n = (o.name || "").toLowerCase();
        allVals += " " + (o.value || "");
        if (n === "size") size = o.value;
        // Regular prints call it "Material"; blends call it "Product"
        // (Fine Art / Metal / Canvas). Accept either.
        if (n === "material" || n === "product") material = o.value;
      });
    }
    if ((!size || !material) && item.variant_title) {
      var parts = item.variant_title.split("/").map(function (s) { return s.trim(); });
      allVals += " " + item.variant_title;
      if (!size) size = parts[parts.length - 1];
      if (!material && parts.length >= 2) material = parts[parts.length - 2];
    }
    // Frames are paper-only. Anything that mentions metal or canvas in ANY
    // option (regardless of which option holds it) is not a paper print.
    var paper = !/metal|canvas/i.test(material + " " + allVals);
    return { size: size, material: material, paper: paper };
  }
  function handleFromItem(item) {
    if (item.handle) return item.handle;
    var m = (item.url || "").match(/\/products\/([^?\/]+)/);
    return m ? m[1] : "";
  }

  // ---- cart-add interception (fetch + XHR) -------------------------------
  function watchCart() {
    var of = window.fetch;
    if (of) {
      window.fetch = function () {
        var url = (typeof arguments[0] === "string") ? arguments[0] : (arguments[0] && arguments[0].url) || "";
        var p = of.apply(this, arguments);
        if (/\/cart\/add(\.js)?(\?|$)/.test(url) && !state.suppress) {
          p.then(function (res) {
            try { res.clone().json().then(onCartAdd).catch(function () {}); } catch (e) {}
          });
        }
        return p;
      };
    }
    // XHR fallback (older add paths)
    var open = XMLHttpRequest.prototype.open, send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__fuUrl = u; return open.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      if (/\/cart\/add(\.js)?(\?|$)/.test(xhr.__fuUrl || "") && !state.suppress) {
        xhr.addEventListener("load", function () {
          try { onCartAdd(JSON.parse(xhr.responseText)); } catch (e) {}
        });
      }
      return send.apply(this, arguments);
    };
  }

  function onCartAdd(data) {
    if (state.suppress || state.open || !data) return;
    var items = data.items ? data.items : (data.id ? [data] : []);
    var found = null;
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (handleFromItem(item) === FRAMES_HANDLE) continue;     // never upsell a frame
      var spec = itemSpecs(item);
      if (!spec.paper) continue;                                // paper only (skip metal/canvas)
      found = spec; break;
    }
    if (!found) return;
    loadFrames().then(function (map) {
      var key = Object.keys(map).find(function (k) { return normSize(k) === normSize(found.size); });
      if (!key) return;                                          // 4x6 / no matching frame
      // Don't nag if a frame of this size is already in the cart.
      fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
        var ids = {};
        map[key].forEach(function (f) { ids[f.variantId] = 1; });
        var has = (cart.items || []).some(function (li) { return ids[li.variant_id || li.id]; });
        if (!has) showWhenFree(key, map[key]);
      }).catch(function () { showWhenFree(key, map[key]); });
    });
  }

  // ---- styles ------------------------------------------------------------
  function injectCSS() {
    if (state.cssDone) return; state.cssDone = true;
    var css = ""
      + ".fu-overlay{position:fixed;inset:0;background:rgba(10,10,10,.55);display:flex;align-items:center;justify-content:center;z-index:999999;padding:18px;font-family:" + FONT + ";-webkit-font-smoothing:antialiased;opacity:0;transition:opacity .18s}"
      + ".fu-overlay.in{opacity:1}"
      + ".fu-modal{background:#fff;color:" + INK + ";width:100%;max-width:660px;border:1.5px solid " + INK + ";padding:32px 32px 28px;position:relative;transform:translateY(8px);transition:transform .18s;box-sizing:border-box}"
      + ".fu-overlay.in .fu-modal{transform:none}"
      + ".fu-modal *{box-sizing:border-box}"
      + ".fu-close{position:absolute;top:10px;right:12px;background:none;border:0;font-size:26px;line-height:1;cursor:pointer;color:" + INK + ";opacity:.5}"
      + ".fu-close:hover{opacity:1}"
      + ".fu-eyebrow{font-size:11px;letter-spacing:.16em;text-transform:uppercase;font-weight:700;color:" + INK + ";opacity:.55;margin-bottom:6px}"
      + ".fu-h{font-size:25px;font-weight:800;letter-spacing:-.4px;margin:0 0 20px;line-height:1.12}"
      + ".fu-swatches{display:flex;gap:14px;margin-bottom:24px}"
      + ".fu-swatch{flex:1;background:#fff;border:1.5px solid rgba(10,10,10,.18);padding:10px 10px 12px;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:10px;font:inherit;transition:border-color .12s}"
      + ".fu-swatch:hover{border-color:" + INK + "}"
      + ".fu-swatch.sel{border:2px solid " + INK + ";box-shadow:inset 0 0 0 2px " + YELLOW + "}"
      + ".fu-sw-img{width:100%;aspect-ratio:4/5;background-size:cover;background-position:center;background-color:#f2f0ea}"
      + ".fu-sw-name{font-size:13px;letter-spacing:.05em;text-transform:uppercase;font-weight:600}"
      + ".fu-actions{display:flex;flex-direction:column;gap:11px}"
      + ".fu-add{font:inherit;font-size:14px;letter-spacing:.1em;text-transform:uppercase;font-weight:700;padding:17px;border:1.5px solid " + INK + ";background:" + INK + ";color:#fff;cursor:pointer;transition:background .12s,color .12s}"
      + ".fu-add:hover{background:" + YELLOW + ";color:" + INK + "}"
      + ".fu-add[disabled]{opacity:.6;cursor:default}"
      /* DECLINE MUST NOT BE A DARK PATTERN (Ryan 2026-07-29: "I hate when
         companies do that"). It used to be 12.5px, unfilled, borderless,
         underlined AND opacity .6 - four separate signals all making it
         weaker than the accept. Now it matches .fu-add on font-size, weight,
         letter-spacing, padding and hit area, at FULL opacity. It stays
         visually secondary through outline-vs-filled only, which is honest.
         Do not shrink it or fade it again. */
      + ".fu-no{font:inherit;font-size:14px;letter-spacing:.1em;text-transform:uppercase;font-weight:700;padding:17px;border:1.5px solid " + INK + ";background:none;color:" + INK + ";cursor:pointer;transition:background .12s,color .12s}"
      + ".fu-no:hover{background:" + INK + ";color:#fff}"
      + ".fu-done{text-align:center;padding:14px 0 4px}"
      + ".fu-done .fu-check{display:inline-flex;align-items:center;justify-content:center;width:46px;height:46px;border-radius:50%;background:" + YELLOW + ";margin-bottom:12px;font-size:24px;font-weight:800}"
      + ".fu-done h4{margin:0 0 4px;font-size:17px;font-weight:800}"
      + ".fu-done p{margin:0;font-size:13px;opacity:.7}";
    var tag = document.createElement("style");
    tag.id = "fu-style";
    tag.textContent = css;
    document.head.appendChild(tag);
  }

  // ---- popup -------------------------------------------------------------
  // Defer the frame offer until any other 08L modal (e.g. the blend builder)
  // has closed, so two popups never stack. Shared lock: window.__OL_MODAL.
  function showWhenFree(size, frames) {
    if (!window.__OL_MODAL) { showPopup(size, frames); return; }
    var tries = 0;
    var iv = setInterval(function () {
      if (!window.__OL_MODAL) { clearInterval(iv); if (!state.open) showPopup(size, frames); }
      else if (++tries > 40) { clearInterval(iv); }
    }, 300);
  }

  function showPopup(size, frames) {
    if (state.open) return; state.open = true; window.__OL_MODAL = true;
    injectCSS();
    var selected = 0;
    var price = frames[0] ? frames[0].price : 0;

    var swHTML = frames.map(function (f, i) {
      return '<button type="button" class="fu-swatch' + (i === 0 ? " sel" : "") + '" data-i="' + i + '">'
        + '<span class="fu-sw-img" style="background-image:url(\'' + esc(f.image) + '\')"></span>'
        + '<span class="fu-sw-name">' + esc(f.color) + '</span></button>';
    }).join("");

    var ov = document.createElement("div");
    ov.className = "fu-overlay";
    ov.innerHTML = ''
      + '<div class="fu-modal" role="dialog" aria-modal="true" aria-label="Add a matching frame">'
      + '  <button type="button" class="fu-close" aria-label="Close">&times;</button>'
      + '  <div class="fu-eyebrow">Complete your print</div>'
      + '  <h3 class="fu-h">Add a matching ' + esc(size) + ' frame?</h3>'
      + '  <div class="fu-swatches">' + swHTML + '</div>'
      + '  <div class="fu-actions">'
      + '    <button type="button" class="fu-add">Add frame &mdash; <span class="fu-price">' + money(price) + '</span></button>'
      + '    <button type="button" class="fu-no">No thanks</button>'
      + '  </div>'
      + '</div>';
    document.body.appendChild(ov);
    requestAnimationFrame(function () { ov.classList.add("in"); });

    function close() {
      ov.classList.remove("in");
      setTimeout(function () { ov.remove(); state.open = false; window.__OL_MODAL = false; document.removeEventListener("keydown", onKey); }, 180);
    }
    function onKey(e) { if (e.key === "Escape") close(); }
    document.addEventListener("keydown", onKey);

    ov.addEventListener("click", function (e) { if (e.target === ov) close(); });
    ov.querySelector(".fu-close").addEventListener("click", close);
    ov.querySelector(".fu-no").addEventListener("click", close);

    ov.querySelectorAll(".fu-swatch").forEach(function (btn) {
      btn.addEventListener("click", function () {
        selected = Number(btn.dataset.i);
        ov.querySelectorAll(".fu-swatch").forEach(function (b) { b.classList.toggle("sel", b === btn); });
      });
    });

    ov.querySelector(".fu-add").addEventListener("click", function () {
      var f = frames[selected];
      var btn = ov.querySelector(".fu-add");
      btn.disabled = true; btn.textContent = "Adding...";
      addFrame(f.variantId, cartSectionIds()).then(function (addRes) {
        refreshCart(addRes);
        ov.querySelector(".fu-modal").innerHTML =
          '<div class="fu-done"><div class="fu-check">&#10003;</div>'
          + '<h4>Frame added</h4><p>Your ' + esc(size) + " " + esc(f.color) + " frame is in the cart.</p></div>";
        setTimeout(close, 1500);
      }).catch(function () {
        btn.disabled = false; btn.textContent = "Try again";
      });
    });
  }

  // Cart-related section IDs in the DOM. Horizon re-renders ("morphs") these
  // from the cart:update event, so we request their fresh HTML on add.
  function cartSectionIds() {
    var ids = {};
    document.querySelectorAll("cart-items-component, cart-drawer-component, cart-icon").forEach(function (el) {
      var sid = el.getAttribute("data-section-id");
      if (!sid) { var host = el.closest("[data-section-id]"); sid = host && host.getAttribute("data-section-id"); }
      if (sid) ids[sid] = 1;
    });
    return Object.keys(ids);
  }

  function addFrame(variantId, sectionIds) {
    state.suppress = true;
    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (sectionIds && sectionIds.length) { body.sections = sectionIds.join(","); body.sections_url = location.pathname; }
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error("add failed " + r.status);
      return r.json();
    }).finally(function () { state.suppress = false; });
  }

  // Tell the theme its cart changed. This store (Horizon) listens for
  // "cart:update" (ThemeEvents.cartUpdate) and morphs the cart sections from
  // event.detail.data.sections, updating the count from data.itemCount. We also
  // fire a few generic names as a harmless fallback for other themes.
  function refreshCart(addRes) {
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
      var sections = (addRes && addRes.sections) || {};
      try {
        document.dispatchEvent(new CustomEvent("cart:update", {
          bubbles: true,
          detail: { resource: {}, sourceId: "frame-upsell", data: { itemCount: cart.item_count, source: "frame-upsell", sections: sections } }
        }));
      } catch (e) {}
      ["cart:refresh", "cart:updated", "cart:change"].forEach(function (name) {
        try { document.documentElement.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: cart } })); } catch (e) {}
      });
    }).catch(function () {});
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", watchCart);
  else watchCart();
})();
